export function operacaoPostoMigraGestoresFrentistaInRequest(params = {}) {
  return {
    type: '@operacaopostomigragestoresfrentista/POSTOMIGRAGESTORESFRENTISTA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoPostoMigraGestoresFrentista(poco_codigo) {
  return {
    type: '@operacaopostomigragestoresfrentista/FIND_POSTOMIGRAGESTORESFRENTISTA',
    payload: { poco_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaopostomigragestoresfrentista/FAILED_REQUEST',
  };
}

export function deleteOperacaoPostoMigraGestoresFrentista(poco_codigo, params) {
  return {
    type: '@operacaopostomigragestoresfrentista/DELETE_POSTOMIGRAGESTORESFRENTISTA',
    payload: { poco_codigo, params },
  };
}

export function updateOperacaoPostoMigraGestoresFrentista(operacaopostomigragestoresfrentista, params) {
  return {
    type: '@operacaopostomigragestoresfrentista/UPDATE_POSTOMIGRAGESTORESFRENTISTA',
    payload: { operacaopostomigragestoresfrentista, params },
  };
}

export function storeOperacaoPostoMigraGestoresFrentista(operacaopostomigragestoresfrentista, params) {
  return {
    type: '@operacaopostomigragestoresfrentista/STORE_POSTOMIGRAGESTORESFRENTISTA',
    payload: { operacaopostomigragestoresfrentista, params },
  };
}

export function successInRequest(
  operacaopostomigragestoresfrentista,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaopostomigragestoresfrentista/SUCCESS_IN_REQUEST',
    payload: { operacaopostomigragestoresfrentista, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaopostomigragestoresfrentista) {
  return {
    type: '@operacaopostomigragestoresfrentista/SUCCESS_REQUEST',
    payload: { operacaopostomigragestoresfrentista },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaopostomigragestoresfrentista/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaopostomigragestoresfrentista/RECORD_FILTERING',
    payload: { params },
  };
}
